function AnchorLinkScrolling() {
    let params = (new URL(document.location)).searchParams;
    let nav = params.get('nav');

    let target = $("#" + nav);

    if (target.length != 0) {
        $("html, body").animate({
            scrollTop: target.offset().top - 75
        }, 1000);
    }
}

export { AnchorLinkScrolling };